export default "__VITE_ASSET__MBnOt_cE__"